/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { eventControllerCreate } from '../fn/events/event-controller-create';
import { EventControllerCreate$Params } from '../fn/events/event-controller-create';
import { eventControllerGetAll } from '../fn/events/event-controller-get-all';
import { EventControllerGetAll$Params } from '../fn/events/event-controller-get-all';
import { eventControllerGetAllTypes } from '../fn/events/event-controller-get-all-types';
import { EventControllerGetAllTypes$Params } from '../fn/events/event-controller-get-all-types';
import { eventControllerGetOne } from '../fn/events/event-controller-get-one';
import { EventControllerGetOne$Params } from '../fn/events/event-controller-get-one';
import { eventControllerUpdate } from '../fn/events/event-controller-update';
import { EventControllerUpdate$Params } from '../fn/events/event-controller-update';
import { EventItem } from '../models/event-item';
import { EventItemList } from '../models/event-item-list';
import { eventStatusControllerGetAll } from '../fn/events/event-status-controller-get-all';
import { EventStatusControllerGetAll$Params } from '../fn/events/event-status-controller-get-all';
import { EventStatusItemList } from '../models/event-status-item-list';
import { EventTypeItemList } from '../models/event-type-item-list';

@Injectable({ providedIn: 'root' })
export class EventsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `eventControllerGetAll()` */
  static readonly EventControllerGetAllPath = '/monitoring/{monitoringId}/events';

  /**
   * Ritorna tutti gli eventi di un monitoraggio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerGetAll$Response(params: EventControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EventItemList;
}>> {
    const obs = eventControllerGetAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ritorna tutti gli eventi di un monitoraggio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerGetAll(params: EventControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EventItemList;
}> {
    const resp = this.eventControllerGetAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EventItemList;
}>): BaseResponse & {
'data'?: EventItemList;
} => r.body)
    );
  }

  /** Path part for operation `eventControllerCreate()` */
  static readonly EventControllerCreatePath = '/monitoring/{monitoringId}/events';

  /**
   * Crea un evento su un monitoraggio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventControllerCreate$Response(params: EventControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EventItem;
}>> {
    const obs = eventControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Crea un evento su un monitoraggio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventControllerCreate(params: EventControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EventItem;
}> {
    const resp = this.eventControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EventItem;
}>): BaseResponse & {
'data'?: EventItem;
} => r.body)
    );
  }

  /** Path part for operation `eventControllerGetAllTypes()` */
  static readonly EventControllerGetAllTypesPath = '/monitoring/{monitoringId}/events/types';

  /**
   * Ritorna l'elenco dei tipi degli evenit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventControllerGetAllTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerGetAllTypes$Response(params?: EventControllerGetAllTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EventTypeItemList;
}>> {
    const obs = eventControllerGetAllTypes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ritorna l'elenco dei tipi degli evenit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventControllerGetAllTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerGetAllTypes(params?: EventControllerGetAllTypes$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EventTypeItemList;
}> {
    const resp = this.eventControllerGetAllTypes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EventTypeItemList;
}>): BaseResponse & {
'data'?: EventTypeItemList;
} => r.body)
    );
  }

  /** Path part for operation `eventControllerGetOne()` */
  static readonly EventControllerGetOnePath = '/monitoring/{monitoringId}/events/{id}';

  /**
   * Ritorna un evento per id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventControllerGetOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerGetOne$Response(params: EventControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EventItem;
}>> {
    const obs = eventControllerGetOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ritorna un evento per id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventControllerGetOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventControllerGetOne(params: EventControllerGetOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EventItem;
}> {
    const resp = this.eventControllerGetOne$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EventItem;
}>): BaseResponse & {
'data'?: EventItem;
} => r.body)
    );
  }

  /** Path part for operation `eventControllerUpdate()` */
  static readonly EventControllerUpdatePath = '/monitoring/{monitoringId}/events/{id}';

  /**
   * Aggiorna un evento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventControllerUpdate$Response(params: EventControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EventItem;
}>> {
    const obs = eventControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Aggiorna un evento.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventControllerUpdate(params: EventControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EventItem;
}> {
    const resp = this.eventControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EventItem;
}>): BaseResponse & {
'data'?: EventItem;
} => r.body)
    );
  }

  /** Path part for operation `eventStatusControllerGetAll()` */
  static readonly EventStatusControllerGetAllPath = '/event-statuses';

  /**
   * Ritorna gli stati disponibili degli eventi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventStatusControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventStatusControllerGetAll$Response(params?: EventStatusControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EventStatusItemList;
}>> {
    const obs = eventStatusControllerGetAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ritorna gli stati disponibili degli eventi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventStatusControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventStatusControllerGetAll(params?: EventStatusControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EventStatusItemList;
}> {
    const resp = this.eventStatusControllerGetAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EventStatusItemList;
}>): BaseResponse & {
'data'?: EventStatusItemList;
} => r.body)
    );
  }

}
